import io from 'socket.io-client';
import { typedLocalStorage } from '../../../utils/typedLocalStorage';
export class SocketService {
    constructor(serverParams) {
        this.channel = 'widget';
        this.listeners = [];
        this.initUserData = null;
        this.joinResponseData = null;
        this.socketConnection = io({ path: '/socket-chat/socket.io' });
        this.serverParams = serverParams;
        this.clientId = String(serverParams.initParamData.clientId);
        this.joinResponseSocketListener();
        this.newMessageSocketListener();
        this.deleteMessageSocketListener();
    }
    registerChat(userData) {
        const data = Object.assign(Object.assign({ client_id: this.clientId, channel: this.channel }, this.serverParams.user), userData);
        typedLocalStorage.setItem('userData', JSON.stringify(userData));
        this.initUserData = Object.assign({}, userData);
        this.joinResponseData = null;
        this.socketConnection.emit('join', data);
    }
    joinResponseSocketListener() {
        this.socketConnection.on('join response', (response) => {
            if (response.status)
                this.joinResponseData = response.data;
            this.notifyListeners('join response', response.data);
        });
    }
    newMessageSocketListener() {
        this.socketConnection.on('new message', (messageDTO) => {
            var _a, _b, _c, _d;
            /* send parent script signal to show notification */
            window.parent.postMessage({ type: 'new message' }, '*');
            /* Проверяем, если пришли новые данные админа, то обновляем joinResponseData */
            if (messageDTO.channel === 'admin' &&
                (((_b = (_a = this.joinResponseData) === null || _a === void 0 ? void 0 : _a.executor) === null || _b === void 0 ? void 0 : _b.name) !== messageDTO.user.name ||
                    ((_d = (_c = this.joinResponseData) === null || _c === void 0 ? void 0 : _c.executor) === null || _d === void 0 ? void 0 : _d.email) !== messageDTO.user.email)) {
                const data = Object.assign(Object.assign({ client_id: this.clientId, channel: this.channel }, this.serverParams.user), this.initUserData);
                this.socketConnection.emit('join', data);
            }
            this.notifyListeners('new message', messageDTO);
        });
    }
    deleteMessageSocketListener() {
        this.socketConnection.on('message deleted', (data) => {
            window.parent.postMessage({ type: 'message deleted' }, '*');
            this.notifyListeners('message deleted', data);
        });
    }
    sendMessageEmit({ text, replyToId, files }) {
        var _a, _b, _c, _d, _e, _f, _g;
        const messageData = Object.assign({ text, parent_message_id: replyToId || null, files: files || null, channel: this.channel, is_admin: false, name: ((_a = this.joinResponseData) === null || _a === void 0 ? void 0 : _a.user.name) || ((_b = this.initUserData) === null || _b === void 0 ? void 0 : _b.name), email: ((_c = this.joinResponseData) === null || _c === void 0 ? void 0 : _c.user.email) || ((_d = this.initUserData) === null || _d === void 0 ? void 0 : _d.email), client_id: this.clientId || null, chat_key: ((_e = this.joinResponseData) === null || _e === void 0 ? void 0 : _e.chat_key) || null, user_id: ((_f = this.joinResponseData) === null || _f === void 0 ? void 0 : _f.user_id) || null, image_url: ((_g = this.joinResponseData) === null || _g === void 0 ? void 0 : _g.user.image_url) || undefined }, this.serverParams.user);
        this.socketConnection.emit('send message', messageData);
    }
    deleteMessageEmit(messageId) {
        var _a, _b;
        this.socketConnection.emit('delete message', {
            id: String(messageId),
            client_id: this.clientId,
            channel: this.channel,
            user_id: (_a = this.joinResponseData) === null || _a === void 0 ? void 0 : _a.user_id,
            chat_key: (_b = this.joinResponseData) === null || _b === void 0 ? void 0 : _b.chat_key,
        });
    }
    /** Позволяет подписаться на события из React-компонента */
    addEventListener(eventListener) {
        this.listeners.push(eventListener);
    }
    removeEventListener(eventListener) {
        this.listeners = this.listeners.filter((listener) => listener !== eventListener);
    }
    /** Оповещает подписчиков об изменениях */
    notifyListeners(eventName, data) {
        this.listeners.forEach((listener) => { var _a; return (_a = listener[eventName]) === null || _a === void 0 ? void 0 : _a.call(listener, data); });
    }
}
